import React from "react";
import { Formik, Field, Form, FieldArray } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { TextArea } from "components/form";
import { GalleryField } from "components/form";
import SearchSelect from "utils/SearchSelect";
import MultySearchSelect from "utils/MultySearchSelect";
import extractValues from "utils/extractValues";
import MetaDataComponent from "utils/MetaDataComponent";
import TextFieldSlug from "components/form/TextFieldSlug";
// components
export const PlayerPosition = [
  { label: "دروازه‌بان", value: "GK" },
  { label: "مدافع چپ", value: "LB" },
  { label: "مدافع میانی", value: "CB" },
  { label: "مدافع راست", value: "RB" },
  { label: "هافبک مرکزی", value: "CM" },
  { label: "هافبک چپ", value: "LM" },
  { label: "هافبک راست", value: "RM" },
  { label: "مهاجم مرکزی", value: "CF" },
  { label: "وینگر چپ", value: "LW" },
  { label: "وینگر راست", value: "RW" },
];

const status = [
  { label: "برنامه ریزی شده", value: "scheduled" },
  { label: "درحال اجرا", value: "ongoing" },
  { label: "تکمیل شده", value: "completed" },
  { label: "به تعویق افتاد", value: "postponed" },
  { label: "کنسل شده", value: "canceled" },
];

export default function Add(props) {
  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{
            lineups: [],
            events: [],
            penalties: [],
          }}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const result = extractValues(values, [
              "league",
              "homeTeam",
              "awayTeam",
              "location",
              "referees",
              "lineups.team",
              "lineups.players.player",
              "lineups.substitutes.player",
              "events.team",
              "events.player",
              "events.assistingPlayer",
              "penalties.team",
              "penalties.player",
              "penalties.goalkeeper.player",
            ]);

            await props.submit(result);
            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ values, isSubmitting, dirty, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام:"
                    name="translations.fa.name"
                    slugFieldName="translations.fa.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="name(en)"
                    label="name(en) :"
                    name="translations.en.name"
                    slugFieldName="translations.en.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نامک"
                    label="نامک:"
                    name="translations.fa.slug"
                    component={TextField}
                  />
                  <Field
                    placeholder="نامک(en)"
                    label="نامک(en) :"
                    name="translations.en.slug"
                    component={TextField}
                  />

                  <div className="intro-y">
                    <Field
                      label="لیگ مرتبط :"
                      name="league"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="league"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ بازی :"
                      name="matchDate"
                      component={PersianDataPicker}
                    />
                  </div>

                  <div className="intro-y">
                    <span> شماره هفته بازی در لیگ :</span>
                    <Field
                      label="شماره هفته بازی در لیگ : "
                      name="weekNumber"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" تیم میزبان:"
                      name="homeTeam"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="team"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" تیم مهمان:"
                      name="awayTeam"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="team"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="استادیوم :"
                      name="location"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="stadium"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="وضعیت بازی :"
                      name="status"
                      component={Select}
                      options={status}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> امیتاز تیم میزبان :</span>
                    <Field
                      label="امیتاز تیم میزبان  : "
                      name="homeScore"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> امیتاز تیم مهمان :</span>
                    <Field
                      label="امیتاز تیم مهمان  : "
                      name="awayScore"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> تعداد گل تیم میزبان :</span>
                    <Field
                      label="تعداد گل تیم میزبان  : "
                      name="homeGoals"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> تعداد گل تیم مهمان :</span>
                    <Field
                      label="تعداد گل تیم مهمان  : "
                      name="awayGoals"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span>تعداد تماشاگران :</span>
                    <Field
                      label="تعداد تماشاگران  : "
                      name="attendance"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    label=" داوران:"
                    name="referees"
                    component={MultySearchSelect}
                    searchFields="translations.name,translations.lastName"
                    collectionName="referee"
                    showFields="translations.name,translations.lastName"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <div className="intro-y">
                    <Field
                      label=" برنده:"
                      name="winner"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="team"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    label="ایا وقت اضافه شده است؟ :"
                    name="isExtraTimePlayed"
                    component={Select}
                    options={[
                      { value: true, label: "بله" },
                      { value: false, label: "خیر" },
                    ]}
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label="آیا بازی به ضربات پنالتی کشیده شده است؟ :"
                    name="isPenaltyShootout"
                    component={Select}
                    options={[
                      { value: true, label: "بله" },
                      { value: false, label: "خیر" },
                    ]}
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    placeholder="لینک پخش زنده بازی"
                    label="لینک پخش زنده بازی :"
                    name="broadcastUrl"
                    component={TextField}
                  />

                  <Field
                    placeholder="زمان شروع بازی"
                    label="زمان شروع بازی :"
                    name="startTime"
                    component={TextField}
                  />
                </div>

                <div className="mt-10">
                  <FieldArray name="lineups">
                    {({ push, remove }) => (
                      <div className="border p-4 rounded">
                        <div className="flex items-center justify-between mb-6">
                          <h3 className="font-bold mb-4 text-lg">
                            ترکیب تیم‌ها
                          </h3>
                          <button
                            type="button"
                            onClick={() =>
                              push({ team: "", players: [], formation: "" })
                            }
                            className=" mb-6 px-4 py-2 bg-blue-500 text-white rounded shadow hover:bg-blue-600"
                          >
                            افزودن ترکیب تیم
                          </button>
                        </div>
                        {values?.lineups?.map((lineup, index) => (
                          <div key={`item_${index}`} className="border-b pb-6 mb-6">
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                انتخاب تیم:
                              </label>
                              <Field
                                name={`lineups[${index}].team`}
                                component={SearchSelect}
                                searchFields="translations.name"
                                collectionName="team"
                                showFields="translations.name"
                                placeholder="انتخاب تیم"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                آرایش تیم:
                              </label>
                              <Field
                                name={`lineups[${index}].formation`}
                                placeholder="آرایش تیم (مثلاً 4-3-3)"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <FieldArray name={`lineups[${index}].players`}>
                              {({ push: addPlayer, remove: removePlayer }) => (
                                <div>
                                  <div className="flex items-center justify-between mb-6">
                                    <h4 className="font-bold text-lg mb-4">
                                      بازیکنان
                                    </h4>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        addPlayer({
                                          player: "",
                                          position: "",
                                          shirtNumber: "",
                                          captain: false,
                                          isStarting: false,
                                        })
                                      }
                                      className="mb-4 px-4 py-2 bg-green-500 text-white rounded shadow hover:bg-green-600"
                                    >
                                      افزودن بازیکن
                                    </button>
                                  </div>
                                  {lineup?.players?.map((player, idx) => (
                                    <div
                                      key={idx}
                                      className="mb-6 border p-4 rounded shadow"
                                    >
                                      <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2">
                                          انتخاب بازیکن:
                                        </label>
                                        <Field
                                          name={`lineups[${index}].players[${idx}].player`}
                                          component={SearchSelect}
                                          searchFields="translations.name,translations.lastName"
                                          collectionName="player"
                                          showFields="translations.name,translations.lastName"
                                          placeholder="انتخاب بازیکن"
                                          className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                      </div>
                                      <div className="mb-4">
                                        <Field
                                          label="موقعیت بازیکن:"
                                          name={`lineups[${index}].players[${idx}].position`}
                                          component={Select}
                                          options={PlayerPosition}
                                          className="w-full px-3 py-2 border rounded"
                                        />
                                      </div>
                                      <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2">
                                          شماره پیراهن:
                                        </label>
                                        <Field
                                          name={`lineups[${index}].players[${idx}].shirtNumber`}
                                          type="number"
                                          placeholder="شماره پیراهن"
                                          className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                      </div>

                                      <div className="mb-4">
                                        <Field
                                          label="آیا بازیکن کاپتان هست:"
                                          name={`lineups[${index}].players[${idx}].captain`}
                                          component={Select}
                                          options={[
                                            { value: true, label: "بله" },
                                            { value: false, label: "خیر" },
                                          ]}
                                          className="w-full px-3 py-2 border rounded"
                                        />
                                      </div>

                                      <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2">
                                          شماره سطر:
                                        </label>
                                        <Field
                                          name={`lineups[${index}].players[${idx}].coordinates.x`}
                                          type="number"
                                          placeholder="شماره سطر"
                                          className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                      </div>

                                      <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2">
                                          شماره ستون:
                                        </label>
                                        <Field
                                          name={`lineups[${index}].players[${idx}].coordinates.y`}
                                          type="number"
                                          placeholder="شماره ستون"
                                          className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                      </div>

                                      <button
                                        type="button"
                                        onClick={() => removePlayer(idx)}
                                        className="px-3 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                                      >
                                        حذف بازیکن
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </FieldArray>

                            <FieldArray name={`lineups[${index}].substitutes`}>
                              {({ push: addPlayer, remove: removePlayer }) => (
                                <div>
                                  <div className="flex items-center justify-between mb-6">
                                    <h4 className="font-bold text-lg mb-4">
                                      بازیکنان ذخیره
                                    </h4>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        addPlayer({
                                          player: "",
                                          shirtNumber: "",
                                        })
                                      }
                                      className="mb-4 px-4 py-2 bg-green-500 text-white rounded shadow hover:bg-green-600"
                                    >
                                      افزودن بازیکن ذخیره
                                    </button>
                                  </div>
                                  {lineup?.substitutes?.map((player, idx) => (
                                    <div
                                      key={idx}
                                      className="mb-6 border p-4 rounded shadow"
                                    >
                                      <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2">
                                          انتخاب بازیکن:
                                        </label>
                                        <Field
                                          name={`lineups[${index}].substitutes[${idx}].player`}
                                          component={SearchSelect}
                                          searchFields="translations.name,translations.lastName"
                                          collectionName="player"
                                          showFields="translations.name,translations.lastName"
                                          placeholder="انتخاب بازیکن"
                                          className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                      </div>

                                      <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2">
                                          شماره پیراهن:
                                        </label>
                                        <Field
                                          name={`lineups[${index}].substitutes[${idx}].shirtNumber`}
                                          type="number"
                                          placeholder="شماره پیراهن"
                                          className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                      </div>

                                      <button
                                        type="button"
                                        onClick={() => removePlayer(idx)}
                                        className="px-3 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                                      >
                                        حذف بازیکن ذخیره
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </FieldArray>

                            <button
                              type="button"
                              onClick={() => remove(index)}
                              className="mt-4 px-4 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                            >
                              حذف ترکیب تیم
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </div>
                <div className="mt-10">
                  <FieldArray name="events">
                    {({ push, remove }) => (
                      <div className="border p-4 rounded">
                        <div className="flex items-center justify-between mb-6">
                          <h3 className="font-bold mb-4 text-lg">
                            رویدادهای بازی
                          </h3>
                          <button
                            type="button"
                            onClick={() =>
                              push({
                                minute: "",
                                type: "",
                                team: "",
                                player: "",
                                assistingPlayer: "",
                                position: "",
                              })
                            }
                            className="mb-6 px-4 py-2 bg-blue-500 text-white rounded shadow hover:bg-blue-600"
                          >
                            افزودن رویداد
                          </button>
                        </div>
                        {values?.events?.map((event, index) => (
                          <div key={index} className="border-b pb-6 mb-6">
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                دقیقه رویداد:
                              </label>
                              <Field
                                name={`events[${index}].minute`}
                                type="number"
                                placeholder="دقیقه رویداد"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                نوع رویداد:
                              </label>
                              <Field
                                name={`events[${index}].type`}
                                placeholder="نوع رویداد (مثلاً گل، کارت زرد)"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                تیم مرتبط:
                              </label>
                              <Field
                                name={`events[${index}].team`}
                                component={SearchSelect}
                                searchFields="translations.name"
                                collectionName="team"
                                showFields="translations.name"
                                placeholder="انتخاب تیم"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                بازیکن اصلی:
                              </label>
                              <Field
                                name={`events[${index}].player`}
                                component={SearchSelect}
                                searchFields="translations.name,translations.lastName"
                                collectionName="player"
                                showFields="translations.name,translations.lastName"
                                placeholder="انتخاب بازیکن"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                بازیکن کمک‌کننده:
                              </label>
                              <Field
                                name={`events[${index}].assistingPlayer`}
                                component={SearchSelect}
                                searchFields="translations.name,translations.lastName"
                                collectionName="player"
                                showFields="translations.name,translations.lastName"
                                placeholder="انتخاب بازیکن کمک‌کننده"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                موقعیت بازیکن:
                              </label>
                              <Field
                                name={`events[${index}].position`}
                                placeholder="موقعیت بازیکن (مثلاً FW, GK)"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <button
                              type="button"
                              onClick={() => remove(index)}
                              className="px-4 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                            >
                              حذف رویداد
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </div>
                <div className="mt-10">
                  <FieldArray name="penalties">
                    {({ push, remove }) => (
                      <div className="border p-4 rounded">
                        <div className="flex items-center justify-between mb-6">
                          <h3 className="font-bold mb-4 text-lg">
                            ضربات پنالتی
                          </h3>
                          <button
                            type="button"
                            onClick={() =>
                              push({
                                team: "",
                                player: "",
                                scored: false,
                                minute: "",
                                attemptNumber: "",
                                goalkeeper: { player: "", action: "" },
                              })
                            }
                            className="mb-6 px-4 py-2 bg-blue-500 text-white rounded shadow hover:bg-blue-600"
                          >
                            افزودن پنالتی
                          </button>
                        </div>
                        {values?.penalties?.map((penalty, index) => (
                          <div key={index} className="border-b pb-6 mb-6">
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                تیم مرتبط:
                              </label>
                              <Field
                                name={`penalties[${index}].team`}
                                component={SearchSelect}
                                searchFields="translations.name"
                                collectionName="team"
                                showFields="translations.name"
                                placeholder="انتخاب تیم"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                بازیکن ضربه‌زننده:
                              </label>
                              <Field
                                name={`penalties[${index}].player`}
                                component={SearchSelect}
                                searchFields="translations.name,translations.lastName"
                                collectionName="player"
                                showFields="translations.name,translations.lastName"
                                placeholder="انتخاب بازیکن"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                آیا گل شده است؟
                              </label>
                              <Field
                                name={`penalties[${index}].scored`}
                                component={Select}
                                options={[
                                  { value: true, label: "بله" },
                                  { value: false, label: "خیر" },
                                ]}
                                placeholder="آیا گل شده است؟"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                دقیقه پنالتی:
                              </label>
                              <Field
                                name={`penalties[${index}].minute`}
                                type="number"
                                placeholder="دقیقه"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                شماره تلاش پنالتی:
                              </label>
                              <Field
                                name={`penalties[${index}].attemptNumber`}
                                type="number"
                                placeholder="شماره تلاش"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div className="mb-4">
                              <h4 className="font-bold mb-2">دروازه‌بان</h4>
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                بازیکن دروازه‌بان:
                              </label>
                              <Field
                                name={`penalties[${index}].goalkeeper.player`}
                                component={SearchSelect}
                                searchFields="translations.name,translations.lastName"
                                collectionName="player"
                                showFields="translations.name,translations.lastName"
                                placeholder="انتخاب دروازه‌بان"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />

                              <label className="block text-gray-700 text-sm font-bold mt-4 mb-2">
                                واکنش دروازه‌بان:
                              </label>
                              <Field
                                name={`penalties[${index}].goalkeeper.action`}
                                placeholder='واکنش (مثلاً "saved", "missed")'
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <button
                              type="button"
                              onClick={() => remove(index)}
                              className="px-4 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                            >
                              حذف پنالتی
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </FieldArray>

                  <MetaDataComponent
                    values={values}
                    setFieldValue={setFieldValue}
                    type="Match"
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
